<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :modal="false"
      :visible.sync="innerVisible"
      width="295px"
      :title="$t('CargoMsg.Cargo_BatchUpload')"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div>
          <div class="form-row" style="flex-direction:row;text-align:center;">
            <div style="padding-bottom: 20px">
              {{ $t('CargoMsg.Cargo_PleaseSelectBusinessData') }}
            </div>
            <div>
              <el-radio-group v-model="pageRadio" no="1">
                <el-radio label="mblNo">{{ $t('SeaExport.BlNo') }}</el-radio>
                <el-radio label="jobNo">{{ $t('SeaExport.BusinessNo') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" style="text-align:center">
          <el-button type="primary" no="2" @click="selectedHandler">
            {{ $t('common.btn.confirm') }}
          </el-button>

          <el-button no="3" @click="cancel">
            {{ $t('common.btn.cancel') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { Project } from '@/class/model/pm/Project'

export default {
  name: 'SelectBoxWindow',
  components: { cargoCloudFileUpload, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: false, default: 'SE' }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      pageRadio: 'mblNo',
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: this.lob,
        batchUploadData: {}
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    selectedHandler() {
      // 选择后打开文件上传弹框
      this.cloudFile.job.lob = this.lob
      this.cloudFile.visible = true
      if (this.pageRadio === 'mblNo') {
        this.cloudFile.batchUploadData.isMbl = 1
      } else {
        this.cloudFile.batchUploadData.isJobNo = 1
      }
      this.$emit('selectBoxCloseHandler', this.cloudFile)
    }
  }
}
</script>
<style scoped>
ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

